/* unplugin-vue-components disabled */import { render } from "./LogicalReasoning2DQuestion.vue?vue&type=template&id=15a60f6c&scoped=true"
import script from "./LogicalReasoning2DQuestion.vue?vue&type=script&lang=js"
export * from "./LogicalReasoning2DQuestion.vue?vue&type=script&lang=js"

import "./LogicalReasoning2DQuestion.vue?vue&type=style&index=0&id=15a60f6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a60f6c"]])

export default __exports__